import { boolean, date, object, string, } from 'yup';
import { mobilePhoneRegex } from '@enquiryForm/validation/testPhone';
const formSpec = {
    firstName: string().required('This field is required'),
    surname: string().required('This field is required'),
    dateOfBirth: date().required('This field is required'),
    mobile: string().required('This field is required').matches(mobilePhoneRegex, {
        message: 'Phone number is invalid',
    }),
    email: string()
        .required('This field is required')
        .email('Please enter a valid email address'),
    addressLine1: string().required('This field is required'),
    addressLine2: string(),
    // addressLine3: string(),
    addressTown: string().required('This field is required'),
    addressPostcode: string().required('This field is required'),
    addressCountry: string().required('This field is required'),
    marketingPreferences: boolean(),
};
export const accountFormSchema = object(formSpec);
